// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx, ParamComponent } from 'panel';
type PanelComponentOptions = {
  jsxFactory: TODO;
  attrs?: Record<string, any>;
  props?: Record<string, any>;
  params?: Record<string, any>;
  on?: Record<string, any>;
  hook?: Record<string, any>;
  requiredProps?: string[];
  requiredParams?: string[];
};
export type ReactSnabbdomRendererJsxProps = {
  params: {
    targetPanelComponent?: PanelComponentOptions;
  };
};

// This component's only purpose is to render a target Panel component inside itself and be wrapped by wc2react.
// This allows the target Panel component to avoid wc2react's rendering quirks as it is rendered inside this component instead using snabbdom
export class ReactSnabbdomRenderer extends ParamComponent<ReactSnabbdomRendererJsxProps[`params`]> {
  get config() {
    return {
      template: () => this.renderTemplate(),
      params: {
        targetPanelComponent: {
          type: Object
        }
      }
    };
  }
  renderTemplate() {
    if (this.params.targetPanelComponent) {
      var _this$params$targetPa, _this$params$targetPa3;
      const requiredProps = (_this$params$targetPa = this.params.targetPanelComponent.requiredProps) !== null && _this$params$targetPa !== void 0 ? _this$params$targetPa : [];
      const hasRequiredProps = requiredProps.every(requiredProp => {
        var _this$params$targetPa2;
        // we actually want to specifically check null or undefined
        // eslint-disable-next-line eqeqeq
        return ((_this$params$targetPa2 = this.params.targetPanelComponent.props) === null || _this$params$targetPa2 === void 0 ? void 0 : _this$params$targetPa2[requiredProp]) != null;
      });
      const requiredParams = (_this$params$targetPa3 = this.params.targetPanelComponent.requiredParams) !== null && _this$params$targetPa3 !== void 0 ? _this$params$targetPa3 : [];
      const hasRequiredParams = requiredParams.every(requiredParam => {
        var _this$params$targetPa4;
        // we actually want to specifically check null or undefined
        // eslint-disable-next-line eqeqeq
        return ((_this$params$targetPa4 = this.params.targetPanelComponent.params) === null || _this$params$targetPa4 === void 0 ? void 0 : _this$params$targetPa4[requiredParam]) != null;
      });
      if (hasRequiredProps && hasRequiredParams) {
        const JsxFactory = this.params.targetPanelComponent.jsxFactory;
        const jp = this.params.targetPanelComponent;
        return <JsxFactory attrs={jp.attrs} props={jp.props} params={jp.params} on={jp.on} hook={jp.hook} />;
      }
    }
    // note: don't return "null" or empty fragment in component template, Panel component must have a root DOM element.
    return <div />;
  }
}
customElements.define("mp-react-snabbdom-renderer", ReactSnabbdomRenderer);